export const buildEnvironment = {
"buildId":"69940",
"buildDate":"2021-06-21T21:38:13.690Z",
"buildTimeStamp":1624311493690,
"ngVersion":"9.1.4",
"version":"5.3.3641",
"api":"+19.11",
"environment":"prod",
"production":true
};